type GenericObject = { [key: string]: string };

export const Breakpoints: GenericObject = {
  xs: '320px', // Extra small phones (iPhone SE)
  sm: '480px', // Small phones
  md: '768px', // Tablets (portrait)
  lg: '1024px', // Small laptops
  xl: '1280px', // Desktops
  xxl: '1440px', // Large desktops
  xxxl: '1920px', // extra large monitors
};
